import { Tag, TagCategory } from '~/ducks/asset-tags/data/Tag';

export interface EditTagsDrawerState {
  isEditTagsDrawerOpen: boolean;
  deleteCategoryModalIsOpen: boolean;
  deleteCategoryModalItem?: TagCategory;
  deleteTagModalIsOpen: boolean;
  deleteTagModalItem?: Tag;
}

export const initialEditTagsDrawerState: EditTagsDrawerState = {
  isEditTagsDrawerOpen: false,
  deleteCategoryModalIsOpen: false,
  deleteTagModalIsOpen: false,
};
